import React, {Component} from 'react'

class Total extends Component {
  constructor(props) {
    super(props)
  }

  _calculateFromTo = ()  => {
    const {
      paginationProps: {
        dataSize,
        page,
        sizePerPage,
        pageStartIndex,
        totalSize
      }
    } = this.props
    const offset = Math.abs(1 - pageStartIndex)

    let from = ((page - pageStartIndex) * sizePerPage)
    from = dataSize === 0 ? 0 : from + 1
    let to = Math.min(sizePerPage * (page + offset), dataSize)
    if (to > dataSize) to = dataSize

    return { from: from, to: to, totalSize: totalSize }
  }

  render() {
    const fromToSize = this._calculateFromTo()
    return(
      <span style={{whiteSpace: 'nowrap'}}>
        Show/Download rows {fromToSize.from} to {fromToSize.to} of {fromToSize.totalSize}
      </span>
    )
  }
}

export default Total